"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleSubmit = void 0;
var lodash_1 = __importDefault(require("lodash"));
var react_1 = require("react");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var useHandleSubmit = function (mutation, variables) {
    return (0, react_1.useCallback)(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (body) {
        mutation({ variables: lodash_1.default.merge(variables, { body: body }) });
    }, [mutation, variables]);
};
exports.useHandleSubmit = useHandleSubmit;
